<template>
  <div class="product-price">
    <!-- Precio con descuento -->
    <div v-if="hasDiscount" class="price-container with-discount flex justify-center">
      <div class="original-price flex flex-wrap content-center">
        <span class="currency">$</span>
        <span class="amount">{{ formatPrice(originalPrice) }}</span>
      </div>
      <div class="discounted-price">
        <span class="currency">$</span>
        <span class="amount">{{ formatPrice(discountedPrice) }}</span>
        <span class="discount-badge">-{{ discountPercentage }}%</span>
      </div>
    </div>

    <!-- Precio normal (sin descuento) -->
    <div v-else class="price-container normal">
      <div class="normal-price">
        <span class="currency">$</span>
        <span class="amount">{{ formatPrice(price) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductPrice",
  props: {
    // Objeto pricing completo
    pricing: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasDiscount() {
      return (
        this.pricing.originalPrice &&
        this.pricing.discountedPrice &&
        this.pricing.originalPrice > this.pricing.discountedPrice
      );
    },

    originalPrice() {
      return this.pricing.originalPrice;
    },
    discountedPrice() {
      return this.pricing.discountedPrice;
    },
    discountPercentage() {
      return this.pricing.discountPercentage;
    },
    price() {
      return this.pricing.price;
    },
  },
  methods: {
    formatPrice(price) {
      if (!price) return "0";
      return new Intl.NumberFormat("es-CL").format(price);
    },
  },
};
</script>

<style scoped>
.product-price {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
}

.price-container {
  margin-bottom: 8px;
}

/* Precio con descuento */
.price-container.with-discount .original-price {
  text-decoration: line-through;
  color: #6b7280;
  font-size: 0.875rem;
  margin-bottom: 4px;
  margin-right: 12px;
}

.price-container.with-discount .discounted-price {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
}

.discounted-price .currency,
.discounted-price .amount {
  color: #dc2626;
  font-weight: 700;
  font-size: 1.2rem;
}

.discount-badge {
  background: linear-gradient(135deg, #dc2626, #ef4444);
  color: white;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.2);
}

.savings {
  color: #059669;
  font-size: 0.875rem;
  font-weight: 500;
}

/* Precio normal */
.price-container.normal .normal-price .currency,
.price-container.normal .normal-price .amount {
  color: #1f2937;
  font-weight: 700;
  font-size: 1.2rem;
}

/* Precio original tachado */
.original-price .currency,
.original-price .amount {
  color: #6b7280;
}

/* Información de cuotas */
.installments {
  color: #6b7280;
  font-size: 0.875rem;
  margin-top: 4px;
}

/* Responsivo */
@media (max-width: 640px) {
  .discounted-price .currency,
  .discounted-price .amount,
  .normal-price .currency,
  .normal-price .amount {
    font-size: 1.25rem;
  }

  .discount-badge {
    font-size: 0.7rem;
    padding: 3px 6px;
  }
}
</style>
